import { useContext, useState } from "react";
import useClients from "../../../hooks/useClients";
import { UserContext } from "./../../../context/UserContext";
import ClientInfo from "./ClientInfo/ClientInfo";
import "./Clients.css";

export default function Clients() {
  const [filterGroup, setFilterGroup] = useState("");
  const [searchText, setSearchText] = useState("");
  const [showClientInfoScreen, setShowClientInfoScreen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const {
    user: { lawyer_id },
  } = useContext(UserContext);

  let id = lawyer_id;

  const { clients } = useClients(id);

  console.log(clients);

  const handleRowClick = (c) => {
    setShowClientInfoScreen(true);
    setSelectedClient(c);
  };

  if (showClientInfoScreen) {
    return (
      <ClientInfo
        selectedClient={selectedClient}
        onBack={() => setShowClientInfoScreen(false)}
      />
    );
  }

  return (
    <div className="request-records-page">
      <div className="c-header">
        <h2 className="c-title">Clients</h2>
        <div className="c-header-actions">
          <button className="c-btn c-btn-new">New Client</button>
          <button className="c-btn c-btn-options">Options ▼</button>
        </div>
      </div>

      <div className="c-banner">
        <div className="c-banner-content">
          <strong className="c-banner-title">Making Requests</strong>
          <span className="c-banner-text">
            To begin your record request, select a client from the list below.
            You can then select your provider and products and immediately place
            the request if all authorizations have been approved.
          </span>
        </div>
        <button className="c-banner-close">×</button>
      </div>

      <div className="c-card">
        <h3 className="c-card-title">Clients List</h3>

        <div className="c-filters">
          <select
            className="c-select"
            value={filterGroup}
            onChange={(e) => setFilterGroup(e.target.value)}
          >
            <option value="">Filter groups</option>
            <option value="A">Group A</option>
            <option value="B">Group B</option>
            <option value="C">Group C</option>
          </select>

          <input
            type="text"
            className="c-input"
            placeholder="Search client name or file #"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <table className="c-table">
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>DOB</th>
              <th>File Number</th>
              <th>Groups</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((c) => (
              <tr
                key={c.id}
                className="c-table-row"
                onClick={() => handleRowClick(c)}
              >
                <td>{c.first_name}</td>
                <td>{c.last_name}</td>
                <td>{c.email || "-"}</td>
                <td>{c.dob?.split("T")[0]}</td>
                <td>{c.file_number}</td>
                <td>{"N/A"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="c-pagination">
          <label>
            Show
            <select defaultValue="10">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            entries
          </label>
        </div>
      </div>
    </div>
  );
}
